export default __webpack_public_path__ + "static/media/Land Change.ca238342.gif";